module.exports = __webpack_public_path__ + "img/toggle-right-outline.png";